import type { TFunction } from 'i18next';

import { z } from 'zod';

export const createCompetencesSchema = (t: TFunction) => {
  const competenceSchema = z.string().min(1, t('Forms.Competences.errors.competence'));

  return z.object({
    competences: z
      .array(competenceSchema)
      .min(1, t('Forms.Competences.errors.minCompetences'))
      .max(20, t('Forms.Competences.errors.maxCompetences')),
  });
};

export type CompetencesFormValues = z.infer<ReturnType<typeof createCompetencesSchema>>;
